import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PayResult from "./pages/PayResult";
import { AuthProvider } from "@/lib/auth";
import Landing from "./pages/Landing";
import AuthPage from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import CompanyDashboard from "./pages/CompanyDashboard";
import CrewApp from "./pages/CrewApp";
import DemoPage from "./pages/Demo";
import Admin from "./pages/Admin";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<CompanyDashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/crew" element={<CrewApp />} />

            <Route path="/map" element={<Dashboard />} />
            <Route path="/pay/success" element={<PayResult ok />} />
            <Route path="/pay/canceled" element={<PayResult ok={false} />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
